<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <!-- Titolo toolbar -->
      <v-toolbar-title class="white--text"> Avvisi </v-toolbar-title>

      <v-spacer />

      <!-- Pulsante aggiungi -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
            @click="apriDettaglio(true, {})"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi notifica</span>
      </v-tooltip>

      <v-spacer />

      <!-- Pulsante indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <!-- Tabella notifiche -->
    <v-card-text>
      <v-data-table
        fixed-header
        :headers="headers"
        :items="lista_notifiche"
        height="80vh"
      >
        <!-- Colonna del modifica -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                v-bind="attrs"
                v-on="on"
                @click="apriDettaglio(false, item)"
              >
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Dettaglio</span>
          </v-tooltip>
        </template>

        <!-- Colonna degli allegati -->
        <template v-slot:[`item.allegati`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" @click="apriAllegati(item)">
                <v-icon color="primary">mdi-paperclip</v-icon>
              </v-btn>
            </template>
            <span>Allegati</span>
          </v-tooltip>
        </template>

        <!-- Colonna dell'esito -->
        <template v-slot:[`item.esito`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                v-bind="attrs"
                v-on="on"
                @click="apriListaEsiti(item)"
              >
                <v-icon color="primary">mdi-email-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Esito</span>
          </v-tooltip>
        </template>

        <!-- Colonna dell'eliminazione -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" @click="apriElimina(item)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>

        <!-- Colonna delle immagini -->
        <template v-slot:[`item.immagine`]="{ item }">
          <v-img
            contain
            style="width: 100px; height: 54px"
            :src="item.immagine"
          />
        </template>

        <!-- Colonna del multiplo -->
        <template v-slot:[`item.multipla`]="{ item }">
          <v-icon v-if="item.multipla" color="success">mdi-check</v-icon>
          <v-icon v-else color="error">mdi-close</v-icon>
        </template>

        <!-- Colonna obbligatorio -->
        <template v-slot:[`item.obbligatoria`]="{ item }">
          <v-icon v-if="item.obbligatoria" color="success">mdi-check</v-icon>
          <v-icon v-else color="error">mdi-close</v-icon>
        </template>

        <!-- Formattazione date  -->
        <template v-slot:[`item.data_notifica`]="{ item }">
          {{ formatData(item.data_notifica, false) }}
        </template>

        <template v-slot:[`item.data_fine_validita`]="{ item }">
          {{ formatData(item.data_fine_validita, false) }}
        </template>

        <template v-slot:[`item.data_inizio_validita`]="{ item }">
          {{ formatData(item.data_inizio_validita, false) }}
        </template>
      </v-data-table>

      <!-- Dialog esiti -->
      <v-dialog v-model="dialog_esito" persistent width="50vw">
        <v-card>
          <v-toolbar color="indigo" dense>
            <!-- Titolo toolbar -->
            <v-toolbar-title class="white--text"> Lista esiti </v-toolbar-title>
            <v-spacer> </v-spacer>

            <!-- Pulsante per filtrare -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="getEsitiNotifica" small v-bind="attrs" v-on="on">
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>

            <v-spacer> </v-spacer>

            <!-- Pulsante per tornare indietro -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_esito = false"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                </v-btn>
              </template>
              <span>Indietro</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text class="pt-3">
            <v-container fluid>
              <v-row dense>
                <v-col cols="3">
                  <v-menu
                    v-model="calendario_dalla_data"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        label="Data Da"
                        v-model="data_da_formattata"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtro_dalla_data"
                      @input="calendario_dalla_data = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="calendario_alla_data"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="289"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        hide-details
                        label="Data Da"
                        v-model="data_a_formattata"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtro_alla_data"
                      @input="calendario_alla_data = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    dense
                    hide-details
                    :items="items_cognomi"
                    item-value="id_utente"
                    item-text="nominativo"
                    label="Cognome"
                    v-model="filtro_cognome"
                  >
                    <!-- Tasto per svuotare il filtro -->
                    <template v-slot:append>
                      <v-icon
                        @click="filtro_cognome = null"
                        color="error"
                        v-if="filtro_cognome != null"
                      >
                        mdi-close
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    dense
                    hide-details
                    :items="items_variabili"
                    item-value="id_variabile"
                    item-text="simbolo"
                    label="Variabile"
                    v-model="filtro_variabile"
                  >
                    <!-- Tasto per svuotare il filtro -->
                    <template v-slot:append>
                      <v-icon
                        @click="filtro_variabile = null"
                        color="error"
                        v-if="filtro_variabile != null"
                      >
                        mdi-close
                      </v-icon>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <v-textarea
              v-if="lista_esiti_mancanti != ''"
              outlined
              class="mt-5"
              rows="2"
              v-model="lista_esiti_mancanti"
              readonly
              label="Lista utenti restanti"
            ></v-textarea>
            <v-data-table
              fixed-header
              :headers="headers_esiti"
              :items="lista_esiti"
            >
              <template v-slot:[`item.data_ins`]="{ item }">
                {{ formatData_ora(item.data_ins) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay_esiti" style="z-index: 10">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <!-- Popup dettaglio -->
      <v-dialog v-model="dialog_dettaglio" persistent>
        <DettaglioNotifiche
          :key="dialog_dettaglio"
          :nuovo="dialog_nuovo"
          :selez="dialog_selez"
          :lista_utenti="lista_utenti"
          :lista_profili="lista_profili"
          :lista_notifica_tipi="lista_notifica_tipi"
          :lista_moduli="lista_moduli"
          @click_chiudi_dettaglio="dialog_dettaglio = false"
          @salvataggio="confermaSalvataggio"
        />
      </v-dialog>

      <!-- Popup conferma eliminazione -->
      <v-dialog v-model="dialog_elimina" persistent width="50%">
        <ConfermaEliminazioneNotifiche
          :key="dialog_elimina"
          :selez="dialog_selez"
          @click_chiudi_eliminazione="dialog_elimina = false"
          @click_conferma_eliminazione="setEliminaNotifica(dialog_selez)"
        />
      </v-dialog>

      <!-- Dialog windowframe -->
      <v-dialog class="ma-0 pa-0" v-model="wfVisible" width="90vw">
        <v-card
          class="ma-0 pa-0"
          height="calc(100vh - 100px)"
          style="overflow: hidden"
        >
          <div style="position: relative; height: 100%">
            <WindowFrame
              class="ma-0 pa-0"
              referrerpolicy="origin"
              @click_chiudi="wfVisible = false"
              :component="wfComponent"
              ref="windowframe"
              :input_args="inputArgs"
              :key="keyWf"
            />
          </div>
        </v-card>
      </v-dialog>
    </v-card-text>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Popup avviso (success, orange, error)-->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import moment from "moment";
import DettaglioNotifiche from "@/components/NOTIFICHE/DettaglioNotifiche.vue";
import ConfermaEliminazioneNotifiche from "@/components/NOTIFICHE/ConfermaEliminazioneNotifiche.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "ListaNotifiche",
  components: {
    DettaglioNotifiche,
    ConfermaEliminazioneNotifiche,
    SnackbarQV,
    WindowFrame,
  },
  props: [],
  computed: {
    data_a_formattata() {
      return this.filtro_alla_data != ""
        ? moment(this.filtro_alla_data).format("DD/MM/YYYY")
        : "";
    },
    data_da_formattata() {
      return this.filtro_dalla_data != ""
        ? moment(this.filtro_dalla_data).format("DD/MM/YYYY")
        : "";
    },
  },
  data() {
    return {
      // Variabili di supporto
      filtro_alla_data: "",
      filtro_cognome: null,
      filtro_dalla_data: "",
      filtro_variabile: null,

      //Modali
      calendario_alla_data: false,
      calendario_dalla_data: false,
      dialog_dettaglio: false,
      dialog_elimina: false,
      dialog_nuovo: true,
      dialog_selez: {},
      dialog_esito: false,
      keyWf: true,
      overlay: false,
      overlay_esiti: false,
      wfVisible: false,
      inputArgs: {},
      wfComponent: "",

      //Array
      headers: [
        { text: "", value: "modifica", sortable: false },
        { text: "Allegati", value: "allegati", sortable: false },
        {
          text: "Esito",
          value: "esito",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
          width: "250px",
        },
        { text: "Immagine", value: "immagine", sortable: false },
        { text: "Tipo", value: "tipo_notifica_des", sortable: false }, // DEBUG: { text: "Id", value: "id_notifica", sortable: false},
        { text: "Modulo", value: "id_modulo_des", sortable: false }, // DEBUG: { text: "Id Modulo", value: "id_modulo", sortable: false},
        { text: "Sotto-modulo", value: "id_modulo_menu_des", sortable: false }, // DEBUG: { text: "Id Modulo Menu", value: "id_modulo_menu", sortable: false},
        { text: "Utenti", value: "id_utenti_des", sortable: false }, // DEBUG: { text: "Id Utenti", value: "id_utenti", sortable: false},
        {
          text: "Profili utente",
          value: "id_profilo_utente_des",
          sortable: false,
        }, // DEBUG: { text: "Id Profili utente", value: "id_profilo_utente", sortable: false},
        { text: "Data", value: "data_notifica", sortable: false }, // DEBUG:  { text: "Id Tipo", value: "tipo_notifica", sortable: false},
        {
          text: "Inizio validità",
          value: "data_inizio_validita",
          sortable: false,
        },
        {
          text: "Fine validità",
          value: "data_fine_validita",
          sortable: false,
        },
        {
          text: "Obbligatorio",
          value: "obbligatoria",
          sortable: false,
        },
        { text: "Multiplo", value: "multipla", sortable: false },
        { text: "", value: "elimina", sortable: false },
      ],

      headers_esiti: [
        { text: "Cognome", value: "cognome", sortable: false },
        { text: "Variabile", value: "simbolo", sortable: false },
        { text: "Risposta", value: "risposta", sortable: false },
        { text: "Data", value: "data_ins", sortable: false },
      ],
      items_cognomi: new Array(),
      items_variabili: new Array(),
      lista_moduli: [],
      lista_notifica_tipi: [],
      lista_notifiche: [],
      lista_profili: [],
      lista_utenti: [],
      lista_esiti: [],
      lista_esiti_mancanti: [],
    };
  },

  async mounted() {
    this.overlay = true;
    await this.getListaProfili();
    await this.getListaUtenti();
    await this.getListaNotificaTipi();
    await this.getListaModuli();
    this.overlay = false;
    this.getListaNotifiche();
  },

  methods: {
    apriAllegati(arg) {
      this.inputArgs = {
        cod_riferimento: "t_notifiche",
        id_riferimento: arg.id_notifica,
        pk_riferimento: "id_notifica",
        id_utente: localStorage.id,
      };
      this.wfComponent = "allegati";
      this.wfVisible = true;
    },
    apriDettaglio(is_nuovo, item) {
      this.dialog_nuovo = is_nuovo;
      this.dialog_selez = item;
      this.dialog_dettaglio = true;
    },

    apriElimina(item) {
      this.dialog_elimina = true;
      this.dialog_selez = item;
    },
    apriListaEsiti(arg) {
      this.notifica_sel = JSON.parse(JSON.stringify(arg));
      this.filtro_cognome = null;
      this.filtro_variabile = null;
      this.filtro_alla_data = moment().format("YYYY-MM-DD");
      this.filtro_dalla_data = moment()
        .subtract(14, "days")
        .format("YYYY-MM-DD");

      /* L'overlay sarà chiuso dalla funzione getEsitiNotifica,
       * che per conto suo ne gestisce anche un altro. */
      this.overlay = true;
      this.getEsitiNotifica();
    },
    confermaSalvataggio() {
      this.getListaNotifiche();
      this.dialog_dettaglio = false;
      this.$refs.SnackbarQV.print("success", "Notifica salvata con successo.");
    },

    formatData(arg, american_format) {
      return arg != null && arg != ""
        ? moment(arg).format(american_format ? "YYYY-MM-DD" : "DD/MM/YY")
        : "";
    },

    formatData_ora(arg) {
      return arg != null && arg != ""
        ? moment(arg).format("DD/MM/YYYY - HH:mm")
        : "";
    },
    getEsitiNotifica() {
      const request = {
        controller: "Notifiche",
        method: "POST",
        richiesta: {
          action: "getesitinotifica",
          token: localStorage.user_token,
          id_notifica: this.notifica_sel.id_notifica,
          data_da: `${this.filtro_dalla_data} 00:00:00`,
          data_a: `${this.filtro_alla_data} 23:59:59`,
        },
      };

      if (this.filtro_cognome != null) {
        request.richiesta.id_utente = this.filtro_cognome;
      }

      if (this.filtro_variabile != null) {
        request.richiesta.id_variabile = this.filtro_variabile;
      }

      this.overlay_esiti = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          this.overlay_esiti = false;
          if (res.status === 200) {
            this.lista_esiti_mancanti = "";
            const visualizzato = res.data.result;
            this.items_cognomi = res.data.utenti;
            this.items_variabili = res.data.variabili;

            // Lista degli utenti che non hanno visualizzato
            const temp_id_utenti = this.notifica_sel.id_utenti
              ? this.notifica_sel.id_utenti.split(",").map(Number)
              : [];

            temp_id_utenti.forEach((ut) => {
              let visto = false;
              visualizzato.forEach((utv) => {
                if (utv.id_utente == ut) {
                  visto = true;
                }
              });
              if (visto == false) {
                this.lista_utenti.forEach((lut) => {
                  if (ut == lut.id_utente) {
                    this.lista_esiti_mancanti += lut.cognome + ", ";
                  }
                });
              }
            });

            this.lista_esiti_mancanti = this.lista_esiti_mancanti.slice(0, -2);

            // Valorizzo gli array di supporto.
            this.lista_esiti = visualizzato;
            this.dialog_esito = true;
            this.overlay_esiti = false;
            this.overlay = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay_esiti = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    async getListaModuli() {
      var request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduliazienda",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.lista_moduli = res.data.result.moduli;
            this.lista_moduli.forEach((m) => {
              m.img_modulo = "";
            });
            this.lista_moduli.unshift({
              id_modulo: -1,
              des_modulo: "Login",
            });
          }

          return true;
        })
        .catch((err) => {
          console.log("Errore:");
          console.log(err);

          return false;
        });
    },

    clickIndietro() {
      this.$router.push("/home/notice");
    },

    async getListaNotificaTipi() {
      var request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_NOTIFICA",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.lista_notifica_tipi = res.data;
          }

          return true;
        })
        .catch((err) => {
          console.log("Errore:");
          console.log(err);

          return false;
        });
    },

    getListaNotifiche() {
      var request = {
        controller: "Notifiche",
        method: "POST",
        richiesta: {
          action: "getnotifiche",
          token: localStorage.getItem("user_token"),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.lista_notifiche = res.data.lista;
            for (let item of this.lista_notifiche) {
              // Conversione al formato americano (rimozione orario).
              item.data_notifica = this.formatData(item.data_notifica, true);
              item.data_inizio_validita = this.formatData(
                item.data_inizio_validita,
                true
              );
              item.data_fine_validita = this.formatData(
                item.data_fine_validita,
                true
              );

              item.id_utenti_des = []; // Array per cognomi utenti.
              item.id_profilo_utente_des = []; // Array per profili utenti.
              item.tipo_notifica_des = ""; // Descrizione per tipo notifica.
              item.id_modulo_des = "";

              // Assegna il cognome per ogni ID utente.
              let temp_id_utenti = item.id_utenti
                ? item.id_utenti.split(",").map(Number)
                : [];

              for (let item_utente of temp_id_utenti) {
                for (let item_utente_lista of this.lista_utenti) {
                  if (item_utente == item_utente_lista.id_utente) {
                    item.id_utenti_des.push(item_utente_lista.cognome);
                    break;
                  }
                }
              }

              // Assegna la descrizione profilo per ogni ID profilo.
              let temp_id_profili = item.id_profilo_utente
                ? item.id_profilo_utente.split(",").map(Number)
                : [];

              for (let item_profilo of temp_id_profili) {
                for (let item_profilo_lista of this.lista_profili) {
                  if (item_profilo == item_profilo_lista.id_profilo_utente) {
                    item.id_profilo_utente_des.push(
                      item_profilo_lista.des_profilo_utente
                    );
                    break;
                  }
                }
              }

              // Assegna la descrizione notifica per l'ID notifica.
              for (let item_notifica_tipo_lista of this.lista_notifica_tipi) {
                if (item.tipo_notifica == item_notifica_tipo_lista.id_tabella) {
                  item.tipo_notifica_des = item_notifica_tipo_lista.des;
                  break;
                }
              }

              // Assegna la descrizione modulo per l'ID modulo.
              for (let item_modulo_lista of this.lista_moduli) {
                if (item.id_modulo == item_modulo_lista.id_modulo) {
                  item.id_modulo_des = item_modulo_lista.des_modulo;

                  // Assegna la descrizione sotto-modulo per l'id_modulo_menu.
                  for (let item_modulo_menu of item_modulo_lista.moduli_menu) {
                    if (
                      item.id_modulo_menu == item_modulo_menu.id_modulo_menu
                    ) {
                      item.id_modulo_menu_des = item_modulo_menu.des;
                    }
                  }
                  break;
                }
              }
            }
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.log("Errore:");
          console.log(err);
        });
    },

    async getListaProfili() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_profili = res.data.result.profili
              ? res.data.result.profili
              : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
          return true;
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
          return false;
        });
    },

    async getListaUtenti() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.lista_utenti = res.data.result.utenti
              ? res.data.result.utenti
              : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
          return true;
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
          return false;
        });
    },

    setEliminaNotifica(item) {
      // Imposta la validità a 0 (Elimina).
      let notifica_da_eliminare = {
        id_notifica: item.id_notifica,
        validita: 0,
      };

      var request = {
        controller: "Notifiche",
        method: "PUT",
        richiesta: {
          action: "setnotifiche",
          token: localStorage.getItem("user_token"),
          notifica: notifica_da_eliminare,
        },
      };

      this.dialog_elimina = false;
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.getListaNotifiche();
            this.$refs.SnackbarQV.print(
              "success",
              "Notifica eliminata con successo."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.log("Errore:");
          console.log(err);
        });
    },
  },
};
</script>
